export default __webpack_public_path__ + "static/media/jira.a4ec121e.png";